import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Required: names the action for screen readers, since there is no text. */
  label: string;
  icon: ReactNode;
  size?: 'sm' | 'md';
  /** Gives the button a surface background and border. */
  solid?: boolean;
  /** Highlights the button as the active choice (e.g. an on toggle). */
  active?: boolean;
}

/** A round, icon-only button. `label` becomes its accessible name and tooltip. */
export function IconButton({
  label,
  icon,
  size = 'md',
  solid = false,
  active = false,
  className,
  type,
  ...rest
}: IconButtonProps) {
  const classes = [
    'pt-iconbtn',
    size === 'sm' ? 'pt-iconbtn--sm' : '',
    solid ? 'pt-iconbtn--solid' : '',
    active ? 'pt-iconbtn--active' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button
      type={type ?? 'button'}
      className={classes}
      aria-label={label}
      aria-pressed={active || undefined}
      title={label}
      {...rest}
    >
      {icon}
    </button>
  );
}
